/**
 * Sætter vores egne produkt-"badges" (fx "Intropris med abonnement
 * 1 kr./ble" - samme metafelt-tekst som badgen på forsiden/kollektions-
 * siderne/produktsiden, se snippets/product-badge.liquid) oven på
 * produktkortene på selve Loop-abonnement-siden (Loop Subscriptions-
 * appen, url'en starter med "/a/loop_subscriptions/").
 *
 * HVORFOR dette er nødvendigt: Loop-siden er IKKE en side i vores eget
 * tema - selve produktkortene der bygges 100% af Loop-appens egen kode
 * (deres eget script tegner HTML'en dynamisk). Vores tema har derfor
 * ingen naturlig "krog" til at rendere badgen med almindelig Liquid, som
 * vi ellers gør alle andre steder.
 *
 * HVORDAN vi undgår at det knækker ved en Loop-opdatering: i stedet for
 * at kigge efter Loop's egne CSS-klassenavne (som Loop frit kan omdøbe
 * ved en redesign af deres widget, uden varsel), leder vi udelukkende
 * efter "data-product-handle" (+ data-product-id/data-variant-id), som
 * Loop selv sætter på hvert kort - det er Shopifys EGNE produkt-
 * identifikatorer, og Loop er selv afhængige af dem for at vide, hvad
 * der skal lægges i abonnementet. Skulle de attributter en dag helt
 * forsvinde fra Loop's kort, stopper scriptet bare med at finde noget at
 * matche på (ingen fejl, ingen badges - "fail silently"), fremfor at
 * fejle synligt eller ødelægge Loop's egen visning.
 *
 * Badge-teksterne hentes ikke fra en fast liste her, men én gang fra vores egen
 * lille JSON-visning af bleer-kollektionen (se templates/collection.badges.liquid),
 * så teksten kan rettes pr. produkt i Shopify admin, som med badgen andre steder.
 *
 * "Gennemse din ordre"-sidepanelet: Loop sætter også "data-product-handle" på
 * produktlinjen i sidepanelet. Den ligger altid inde i et element, hvis klassenavn
 * indeholder "loop-selected" (fx "loop-selected-variant-container"), og springes
 * over, så badgen ikke havner oven på antal-knapperne (+/-). Hvis klassenavnet
 * skifter, vises badgen blot begge steder (samme "fail silently"-princip).
 */
(function () {
  'use strict';

  // Kør KUN på selve Loop-abonnement-siden - no-op alle andre steder.
  if (window.location.pathname.indexOf('/a/loop_subscriptions/') === -1) {
    return;
  }

  var BADGES_FEED_URL = '/collections/bleer?view=badges';
  var PROCESSED_ATTR = 'data-tt-badge-done';
  var badgeMap = null; // { 'produkt-handle': 'badge-tekst' }
  var badgeMapPromise = null;

  function fetchBadgeMap() {
    if (badgeMapPromise) return badgeMapPromise;
    badgeMapPromise = fetch(BADGES_FEED_URL, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('Badge-feed svarede ' + res.status);
        return res.json();
      })
      .then(function (data) {
        badgeMap = data || {};
        return badgeMap;
      })
      .catch(function (err) {
        // Fail silently - ingen badges er bedre end en knækket side.
        console.warn('[tt-loop-badges] kunne ikke hente badge-data:', err);
        badgeMap = {};
        return badgeMap;
      });
    return badgeMapPromise;
  }

  function applyBadge(cardEl, text) {
    if (!cardEl || cardEl.hasAttribute(PROCESSED_ATTR)) return;
    cardEl.setAttribute(PROCESSED_ATTR, 'true');

    // Kortet skal være positioneret, for at vores badge (position:absolute)
    // kan ligge oven på det i stedet for oppe i et helt andet hjørne af
    // siden. Vi rører kun ved position, hvis Loop ikke allerede selv har
    // sat en - "relative" uden offsets ændrer intet visuelt for et
    // element, der allerede opfører sig som "static" i layoutet.
    var computedPosition = window.getComputedStyle(cardEl).position;
    if (computedPosition === 'static') {
      cardEl.style.position = 'relative';
    }

    var badge = document.createElement('div');
    badge.className = 'tt-loop-badge';
    badge.textContent = text;
    cardEl.appendChild(badge);
  }

  function processCard(cardEl) {
    var handle = cardEl.getAttribute('data-product-handle');
    if (!handle || !badgeMap) return;
    // Spring "Gennemse din ordre"-linjen over (se filens topkommentar).
    if (cardEl.closest('[class*="loop-selected"]')) return;
    var text = badgeMap[handle];
    if (text) applyBadge(cardEl, text);
  }

  function scanForCards(root) {
    if (!badgeMap) return;
    if (root.hasAttribute && root.hasAttribute('data-product-handle')) {
      processCard(root);
    }
    var cards = root.querySelectorAll ? root.querySelectorAll('[data-product-handle]') : [];
    for (var i = 0; i < cards.length; i++) {
      processCard(cards[i]);
    }
  }

  function startObserving() {
    scanForCards(document.body);

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType === 1) scanForCards(node);
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  fetchBadgeMap().then(function () {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startObserving);
    } else {
      startObserving();
    }
  });
})();
